import { FC, memo } from 'react'
import { Button, ButtonProps } from '@chakra-ui/react'

import { ArrowLeft } from 'components/icons'

type Props = ButtonProps

const GoBackButton: FC<Props> = ({ children, ...props }) => {
  return (
    <Button variant="ghost" width="max-content" leftIcon={<ArrowLeft />} {...props}>
      {children}
    </Button>
  )
}

export default memo(GoBackButton)
